import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const createAgentService = async (values) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(`${API_URL}/agent/create-agent`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to create agent. Please try again."
    );
  }
};
export const updateAgentService = async (values, id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.put(
      `${API_URL}/agent/update-agent/${id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw (
      error.response?.data?.message ||
      "Unable to Update agent. Please try again."
    );
  }
};
export const reassignLoanService = async (id, agentId, type) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.put(
      `${API_URL}/agent/reassign-agent/`,
      { id, agentId, type },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw (
      error.response?.data?.message ||
      "Unable to Update agent. Please try again."
    );
  }
};

export const getAllAgentsService = async (page, rowsPerPage) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${API_URL}/agent/get-all-agents`, {
      params: { page: page + 1, limit: rowsPerPage },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to fetch agent. Please try again."
    );
  }
};

export const getAgentByIdService = async (id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${API_URL}/agent/get-agent-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data?.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to fetch agent. Please try again."
    );
  }
};
export const getAgentCollectionService = async (id, startDate, endDate) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${API_URL}/agent/get-agent-collection/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate,
          endDate,
        },
      }
    );
    return response.data?.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to fetch agent. Please try again."
    );
  }
};
export const getTodayCollectionService = async (id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${API_URL}/agent/get-today-list/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        id,
      },
    });
    return response.data?.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to fetch agent. Please try again."
    );
  }
};

export const searchAgentService = async (
  page,
  rowsPerPage,
  searchQuery,
  isGroupCustomer
) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${API_URL}/agent/search-agent`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        search: searchQuery,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to create customer. Please try again."
    );
  }
};
